// socket.js
import { io } from "socket.io-client";
import Cookies from "js-cookie";
import axios from "axios";

let socketInstance = null; // ✅ Declare at module level
const userId = Cookies.get("userId"); // If this might change, pass as a param instead

const getPort = async () => {
    try {
        if (!userId) {
            console.log("User ID not found");
            return null;
        }

        const res = await axios.get(
            `http://api.virtualprachar.com/api/whatsapp/personal/get/user_role/${userId}`
        );

        const port = res.data.data[0].wsc;
        console.log("Port received: ", port);
        return port;
    } catch (e) {
        console.log("Port fetch error: ", e);
        return null;
    }
};

export const getSocket = async () => {
    if (socketInstance) {
        return socketInstance; // ✅ Return the cached socket
    }

    try {
        const port = await getPort();
        if (!port || !userId) return null;

        // customized port
        console.log("Port from socket.js ", port);
        socketInstance = io(`http://147.93.30.221:${port}`, {
            query: { userId },
            transports: ["websocket"],
        });

        // socketInstance = io(`http://localhost:${port}`, {
        //     query: { userId },
        //     transports: ["websocket"],
        // });

        console.log("🔌 Socket connected for userId:", userId);
        return socketInstance;
    } catch (e) {
        console.error("Socket connection error: ", e);
        return null;
    }
};

// Optional helper to disconnect & reset
export const disconnectSocket = () => {
    if (socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
        console.log("🔌 Socket disconnected");
    }
};
